module.exports = __webpack_public_path__ + "img/cobertura.af90a3de.png";